// extracted by mini-css-extract-plugin
export default {"container":"Fkl6Ax6YmE4NKwQApVCo","title":"xQVgGcJgTiUqBpK0ED41","iconContainer":"QB66p3BLbyuq3ru8jXQs","pulse":"V_4mq681iF3YfAjMOt5J"};